import { render, staticRenderFns } from "./EditMailingsModal.vue?vue&type=template&id=555d7fbc&"
import script from "./EditMailingsModal.vue?vue&type=script&lang=js&"
export * from "./EditMailingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports